import { render, staticRenderFns } from "./MmfEditTable.vue?vue&type=template&id=10382120&"
import script from "./MmfEditTable.vue?vue&type=script&lang=js&"
export * from "./MmfEditTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports